// Read-only change log shown at /app/changelog (System Setting › Log Perubahan).
// Newest day first. Each item: { area, title, detail }. Add new entries at the top when a change is released.
const CHANGELOG = [
    {
        date: '12 Oktober 2026',
        note: 'Reka bentuk & jenama.',
        items: [
            {
                area: 'Portal Awam',
                title: 'Reka bentuk semula Laman Utama mengikut Portal Rasmi JAIS',
                detail: 'Laman Utama awam dikemas kini: header jalur rasmi (Jata Negeri Selangor, Logo JAIS, khat "Islamic · Saviour · Obedience" dan nama "Portal Sistem Pengurusan Penguatkuasaan JAIS"); kandungan dalam Bahasa Melayu; butang "Semak Status Aduan" dan "Daftar Untuk Buat Aduan"; kotak "PERINGATAN MESRA" (Seksyen 211, Enakmen Tatacara Jenayah Syariah Selangor 2003); dan footer baharu (Logo BPN, alamat BPN JAIS, Hotline 1 800 88 2424, QR Kajian Kepuasan Pelanggan). Pendaftaran pengguna awam dibuka semula.',
            },
            {
                area: 'Umum',
                title: 'Logo rasmi i-SYAEMS',
                detail: 'Logo rasmi i-SYAEMS kini dipaparkan pada bar sisi (sidebar), skrin log masuk, laman awam, dan sebagai ikon tab pelayar (favicon).',
            },
        ],
    },
    {
        date: '6 Oktober 2026',
        note: 'Pembetulan pepijat.',
        items: [
            {
                area: 'Aduan',
                title: 'Borang 5 — butiran Pemberi Maklumat tidak lagi kosong',
                detail: 'Jika aduan diterima oleh akaun pegawai yang tiada rekod Kakitangan terpaut (pegawai selalunya ada lebih sebuah akaun), butiran Pemberi Maklumat (No. K/P, No. Telefon, Alamat) kini diisi dengan memadankan rekod Kakitangan mengikut NAMA pegawai — tetapi hanya jika padanan tepat satu (unik), supaya borang rasmi tidak sesekali memaparkan butiran pegawai lain. Berkesan untuk Export PDF, emel, dan paparan skrin Borang 5.',
            },
            {
                area: 'Aduan',
                title: 'Borang 5 (AK) — nama Pegawai Penguatkuasa Agama kini dipaparkan',
                detail: 'Pada Borang 5 bagi kes AK, nama penandatangan "Pegawai Penguatkuasa Agama" (Pegawai Pengesah) sebelum ini dipaksa kosong dalam PDF/emel. Kini ia dipaparkan seperti kes AJ (dan selaras dengan paparan skrin).',
            },
            {
                area: 'Aduan',
                title: 'Borang 5 (AK) — pegawai pengendali jadi penandatangan bila tiada approver',
                detail: 'Kes AK tidak melalui aliran pengesahan, jadi sesetengahnya tiada Pegawai Pengesah direkodkan (cth apabila akaun pegawai tiada rekod Kakitangan terpaut) — menyebabkan nama penandatangan kosong. Kini Borang 5 AK memaparkan pegawai yang menerima/mengendalikan aduan sebagai "Pegawai Penguatkuasa Agama" apabila tiada approver ditetapkan. Membetulkan kes sedia ada & akan datang secara automatik.',
            },
            {
                area: 'i-Waran',
                title: 'No. Ruj Fail Waran kini ikut daerah bila daerah dibetulkan',
                detail: 'Apabila daerah waran tersalah key-in kemudian dibetulkan dan disimpan, "No. Ruj Fail Waran" (yang sepatutnya auto ikut daerah + tahun) kekal menunjukkan daerah lama — contoh daerah ditukar ke Hulu Selangor tetapi rujukan masih "Klang / 2026 / 0105". Kini apabila daerah (atau tahun) bertukar, No. Ruj Fail Waran dijana semula mengikut daerah yang dipilih daripada jujukan nombor daerah tersebut, dan paparan dikemas kini serta-merta selepas simpan.',
            },
            {
                area: 'Umum',
                title: 'Butang "Kembali" kini kekalkan tapisan carian (daerah, dsb.)',
                detail: 'Dalam Senarai Waran dan Kalendar Waran, selepas membuat carian daerah (cth Klang) dan klik Kemaskini sesuatu rekod, butang "Kembali" sebelum ini membawa ke senarai penuh (semua) dan hilang pilihan daerah. Kini tapisan carian disimpan dalam pautan (URL), jadi "Kembali"/butang Back pelayar memulihkan paparan yang ditapis (daerah/status/tahun) dengan tepat. Pembetulan sama juga digunakan pada Semakan Nama OKT Waran, senarai KES (kategori & skop Aktif/Dipadam) dan Arahan Beredar (skop). Senarai Aduan sudah berfungsi sedemikian.',
            },
            {
                area: 'i-Waran',
                title: 'Preview lampiran & dokumen mahkamah dibaiki ("Gagal membuka preview")',
                detail: 'Sesetengah pengguna gagal membuka preview fail yang dimuat naik (Dokumen Mahkamah / Lampiran) dengan ralat "Gagal membuka preview", walhal pengguna lain berjaya pada fail yang sama. Puncanya pautan muat turun dijana sebagai http:// (bukan https://) kerana pelayan di belakang proksi, lalu disekat pelayar sebagai kandungan tidak selamat (mixed content) — bergantung pada tetapan pelayar setiap pengguna. Kini semua pautan dijana sebagai https dalam produksi, jadi preview berfungsi konsisten untuk semua pengguna.',
            },
        ],
    },
    {
        date: '29 September 2026',
        note: 'Pembetulan pepijat.',
        items: [
            {
                area: 'Aduan',
                title: 'Dropdown "Pilih PPA" (Dikemas kini oleh) kini termasuk PPA HQ',
                detail: 'Dropdown "Dikemas kini oleh (Pilih PPA)" dalam Jana Tindakan › Maklumat Terkini sebelum ini hanya menyenaraikan PPA daerah aduan sahaja, jadi pegawai HQ (yang tiada daerah) tidak muncul — contoh SITI NORHAYU papar "Tiada padanan". Kini senarai termasuk PPA daerah DAN PPA HQ, jadi pegawai HQ boleh dipilih semula.',
            },
        ],
    },
    {
        date: '28 September 2026',
        note: 'Pembetulan pepijat.',
        items: [
            {
                area: 'Aduan',
                title: 'Export PDF Borang 5 — muat turun fail sebenar',
                detail: 'Butang "Export PDF" (Borang 5) kini terus memuat turun fail PDF sebenar (dijana di pelayan, sama seperti lampiran emel Borang 5) — tidak lagi bergantung pada dialog Print pelayar / pilihan "Save as PDF". Ini membetulkan masalah "gagal eksport PDF" apabila dialog cetak set ke pencetak fizikal. Setiap muat turun direkod dalam Audit Trail.',
            },
        ],
    },
    {
        date: '24 September 2026',
        items: [
            {
                area: 'Aduan',
                title: 'Borang Jana Tindakan senaraikan semua No. Daftar Kes',
                detail: 'Bagi aduan yang mempunyai banyak kes, borang Jana Tindakan (paparan, cetakan dan PDF/emel) kini menyenaraikan SEMUA No. Daftar Kes berkaitan, bukan satu sahaja seperti sebelum ini.',
            },
            {
                area: 'Aduan',
                title: 'Ralat semasa simpan Laporan Tindakan dibaiki',
                detail: 'Sesetengah kes gagal disimpan pada Laporan Tindakan (ralat sistem) apabila No. Daftar Kes bertindih dengan kes lain. Telah dibaiki — kes terjejas dinyahsekat, dan sistem kini memaparkan mesej jelas jika No. Daftar Kes sudah digunakan oleh kes lain (bukan ralat sistem).',
            },
        ],
    },
    {
        date: '23 September 2026',
        note: 'Permintaan pengguna.',
        items: [
            {
                area: 'Aduan',
                title: 'Jana Tindakan — buka semula kepada semua pegawai',
                detail: 'Sekatan "hanya Pegawai Inkuiri (PI) boleh mengemas kini Jana Tindakan" telah dibuka semula. Jana Tindakan (Laporan Tindakan) kini boleh dikemas kini oleh Pegawai, Pegawai HQ, Pegawai Daerah dan admin seperti sebelum ini. Nota: kunci PI pada "Maklumat Aduan" dikekalkan.',
            },
            {
                area: 'Aduan',
                title: 'Betulkan Pegawai Pengesah (nama Borang 5) — admin',
                detail: 'Admin/system kini boleh membetulkan "Pegawai Pengesah" dalam Maklumat Aduan (nama yang muncul sebagai penandatangan "Pegawai Penguatkuasa Agama" dalam Borang 5) walaupun aduan sudah Disahkan. Pilih pegawai betul pada dropdown "Pegawai Pengesah" — ia disimpan serta-merta dan hanya menukar pegawai berkenaan; status aduan, "Diterima oleh" dan tarikh TIDAK direset (sebelum ini satu-satunya cara simpan ialah "Hantar Pengesahan" yang akan mengembalikan status ke "Menunggu Pengesahan").',
            },
        ],
    },
    {
        date: '22 September 2026',
        note: 'Pembetulan pepijat.',
        items: [
            {
                area: 'Kakitangan',
                title: 'Checkbox "Tukar E-mel Akaun"',
                detail: 'Dalam Kemaskini Kakitangan, medan E-mel Akaun dan Kata Laluan kini dikunci secara lalai. Untuk menukar/menetapkan akaun, tanda kotak "Tukar / tetapkan E-mel Akaun & kata laluan" dahulu. Ini memastikan kemas kini biasa (nama, telefon, dll.) tidak menyentuh akaun login secara tidak sengaja.',
            },
            {
                area: 'Kakitangan',
                title: 'Ralat "email has already been taken" semasa kemas kini',
                detail: 'Kemas kini kakitangan yang sudah mempunyai akaun (e-mel sama) tidak lagi gagal dengan ralat "The email has already been taken." E-mel kini digunakan untuk memaut akaun sedia ada seperti yang sepatutnya. Sistem tetap menghalang jika e-mel itu milik kakitangan lain (mesej: "E-mel ini sudah digunakan oleh kakitangan lain").',
            },
        ],
    },
    {
        date: '21 September 2026',
        note: 'Permintaan pengguna.',
        items: [
            {
                area: 'Aduan / KES',
                title: 'Betulkan daerah — KES turut ikut sama',
                detail: 'Apabila daerah aduan dibetulkan dalam Maklumat Aduan, KES yang berkaitan kini turut dikemas kini automatik: daerah KES dan No. KES ikut daerah baharu (cth "KES-Petaling/2026/08/0388" menjadi "KES-Hulu Langat/2026/08/0388"; nombor, tahun, bulan kekal). Untuk aduan yang daerahnya sudah dibetulkan sebelum ini tetapi KES masih tersalah, pilih semula daerah yang betul pada aduan dan Simpan — KES akan diselaraskan.',
            },
        ],
    },
    {
        date: '19 September 2026',
        note: 'URS 2.0 — susun semula menu.',
        items: [
            {
                area: 'Aduan',
                title: 'Betulkan daerah — No. Aduan ikut sama',
                detail: 'Apabila daerah aduan dibetulkan dalam Maklumat Aduan (oleh Pegawai Inkuiri atau admin), No. Aduan kini turut dikemas kini automatik mengikut daerah baharu — contoh "AJ-Petaling/2026/08/0311" menjadi "AJ-Hulu Langat/2026/08/0311" (nombor, tahun dan bulan dikekalkan).',
            },
            {
                area: 'Menu',
                title: 'Susun semula menu utama + "Data & Statistik"',
                detail: 'URS 2.0 #1: "Senarai Utama" dinaikkan sebagai menu utama (selepas Dashboard); "Aduan" ditukar nama kepada "FIR"; "Temujanji" jadi "Kalendar Siasatan" (submenu Temujanji AJ & Temujanji AK); "Senarai Arahan Beredar" jadi "Senarai Keseluruhan AB". Menu laporan lama (Laporan Aduan, Laporan Temujanji, Laporan Arahan Beredar, Laporan i-Waran) disembunyikan. Menu baharu "Data & Statistik" dengan 4 submenu (Aduan, Kes, Waran, Arahan Beredar) mengumpulkan semua laporan statistik. Turutan: Dashboard, Senarai Utama, FIR, KES, Jana Tindakan, Kalendar Siasatan, Arahan Beredar, i-Waran, Data & Statistik.',
            },
        ],
    },
    {
        date: '18 September 2026',
        note: 'Permintaan pengguna selepas ujian.',
        items: [
            {
                area: 'Aduan',
                title: 'Format Kesalahan Disyaki diperbetulkan',
                detail: 'Dropdown Kesalahan Disyaki (Tambah Aduan) kini dipaparkan sebagai "Seksyen 25 (EJSS) - Persetubuhan luar nikah" (dahulu "EJSS / Sec 25 - ..."). Dua nama juga dibetulkan: Seksyen 26 kepada "Persediaan melakukan persetubuhan luar nikah" dan Seksyen 121f kepada "Sembelihan halal tanpa perakuan sah".',
            },
            {
                area: 'Arahan Beredar',
                title: 'Daerah, format senarai baharu & muktamad',
                detail: 'URS 2.0 #2: (1) medan "Daerah" (9 daerah) ditambah dalam Tambah/Kemaskini Rekod. (2) Senarai Arahan Beredar kini ikut format: Bil, Maklumat OYDS (nama + No. IC), Maklumat Kejadian, Tarikh, Seksyen Kesalahan, Tindakan PPA. (3) Rekod boleh "Muktamadkan" — selepas itu PPA tidak boleh mengubah; hanya pentadbir boleh buka kunci.',
            },
            {
                area: 'Data & Statistik',
                title: 'Hanya 9 daerah dalam sistem',
                detail: 'URS 2.0 #3: Shah Alam, Ampang dan "Tiada daerah" dikeluarkan daripada pilihan daerah dan daripada semua jadual Data & Statistik. Hanya 9 daerah penguatkuasaan (Petaling, Gombak, Hulu Langat, Klang, Kuala Langat, Sepang, Kuala Selangor, Hulu Selangor, Sabak Bernam) direkodkan. Rekod sedia ada tidak dipadam.',
            },
            {
                area: 'Aduan',
                title: 'Butang "Export PDF" (Borang 5 & Laporan Tindakan)',
                detail: 'URS 2.0 #5: butang "Export PDF" ditambah di sebelah butang Borang 5 (bahagian Maklumat Aduan) dan Laporan Tindakan (dalam KES). Ia membuka paparan cetakan dan terus ke dialog Simpan sebagai PDF.',
            },
            {
                area: 'Aduan',
                title: 'Borang 5: ruang antara Lokasi dan butiran',
                detail: 'URS 2.0 #4: satu baris kosong ditambah antara Lokasi kejadian dan butiran maklumat dalam Borang 5 (AJ) supaya lebih mudah dibaca.',
            },
            {
                area: 'Aduan',
                title: 'Lajur "Dikemas kini oleh" dalam Jana Tindakan',
                detail: 'Jadual Maklumat Terkini (tab Jana Tindakan) kini memaparkan lajur "Dikemas kini oleh". Setiap baris menyimpan pegawai tersendiri: baris hanya dikemas kini dengan nama pegawai semasa apabila kandungannya benar-benar diubah, jadi baris lama kekal menunjukkan siapa yang mengisinya.',
            },
            {
                area: 'i-WARAN',
                title: 'Hantar waran tidak lagi tersekat bila e-mel gagal',
                detail: 'Dahulu, jika e-mel makluman ke pejabat daerah gagal dihantar, waran langsung tidak boleh dihantar ke daerah. Kini waran tetap dihantar, dan e-mel dimasukkan ke baris gilir (database queue) untuk dihantar semula secara automatik apabila pelayan e-mel pulih (cubaan berulang sehingga 3 hari). Pegawai dipaparkan amaran kuning bahawa e-mel belum berjaya. Jika waran langsung tiada alamat e-mel daerah, ia masih disekat supaya HQ mengisi "Email Daerah" dahulu.',
            },
            {
                area: 'Laporan Tindakan (KES)',
                title: 'Label Tarikh / Masa ditukar',
                detail: 'Dalam Laporan Tindakan, label "Tarikh / Masa (Daftar Laporan)" dan "Tarikh / Masa (Tindakan di Lokasi)" ditukar tempat mengikut permintaan (Husairi). Label sahaja yang ditukar; data dan lajur di pangkalan data kekal. Medan yang diisi automatik pada masa simpan kini berlabel "Tindakan di Lokasi", dan medan yang diisi PPA berlabel "Daftar Laporan". Pemetaan Ringkasan KES dikekalkan: Tarikh/Masa Terima = Daftar Laporan, Tarikh/Masa Tindakan = Tindakan di Lokasi.',
            },
            {
                area: 'Manual',
                title: 'Video dan imej dalam Manual Pengguna kini berfungsi',
                detail: 'Video panduan dan imej dalam Manual Pengguna sebelum ini gagal dipaparkan di pelayar. Puncanya konfigurasi pelayan menolak pautan media bertandatangan. Telah dibaiki — semua video dan imej manual kini dimuat dengan betul, termasuk main, jeda dan lompat masa video.',
            },
            {
                area: 'Aduan',
                title: 'Klasifikasi Out of Procedure (OP) dikembalikan',
                detail: 'OP boleh dipilih semula di sebelah NFA dalam Maklumat Aduan dan dalam baris Maklumat Terkini, untuk semua aduan AJ. Sebelum ini OP dibuang pada 14 Sep mengikut URS item 4 ("Keluarkan status OP dari sumber klasifikasi aduan di part Maklumat Aduan"). Pengguna mahu OP dikekalkan, jadi bahagian ini tidak lagi mengikut URS item 4 dan memerlukan pengesahan bertulis JAIS. Laporan statistik memang mengekalkan OP (URS item 16).',
            },
        ],
    },
    {
        date: '17 September 2026',
        items: [
            {
                area: 'Sistem',
                title: 'Akaun ujian untuk semua peranan',
                detail: 'Sembilan akaun ujian (system, admin, PPA HQ, Pegawai Pengesah, Pegawai Inkuiri, pegawai, PPA Petaling, PPA Gombak dan orang awam) boleh dijana oleh pentadbir sistem untuk pelayan ujian. Tidak digunakan di pelayan produksi.',
            },
        ],
    },
    {
        date: '15 September 2026',
        note: 'Maklum balas pengguna selepas ujian URS.',
        items: [
            {
                area: 'Aduan',
                title: 'Subkategori Aduan Keluarga: 6 pilihan',
                detail: 'Tambah Akuan Palsu (hanya perlu Daerah) dan Lewat Mendaftarkan Perkahwinan (medan sama seperti Nikah). Tajuk bahagian ditukar kepada "Maklumat Tambahan" sahaja, dan semua medan di dalamnya tidak lagi wajib bagi keenam-enam pilihan.',
            },
            {
                area: 'Aduan',
                title: 'Teks yang ditaip tidak lagi hilang',
                detail: 'Menukar daerah, tarikh atau medan lain tidak lagi memadam Ringkasan Aduan atau Butiran Borang 5 yang telah ditaip. Sistem bertanya dahulu sebelum menggantikannya dengan templat.',
            },
            {
                area: 'Aduan',
                title: 'Aduan berulang disekat',
                detail: 'Aduan dengan No. K/P, jenis dan butiran yang sama dalam tempoh 30 minit tidak disimpan dua kali. Sistem memaparkan No. Aduan yang sudah wujud.',
            },
            {
                area: 'Aduan',
                title: 'Ralat "Too Many Attempts" dibaiki',
                detail: 'Had penggunaan sistem dinaikkan (60 kepada 300 permintaan seminit bagi setiap pengguna). Jika sistem sibuk, mesej dalam Bahasa Melayu dipaparkan di sebelah butang Hantar, menyatakan aduan belum dihantar dan berapa saat perlu ditunggu.',
            },
            {
                area: 'Aduan',
                title: 'Export butiran penuh aduan ke PDF',
                detail: 'Butang Export PDF dalam paparan aduan menghasilkan butiran penuh: pengadu, kejadian, Borang 5, tindakan, kes, siasatan dan pendakwaan. Setiap muat turun direkod dalam Audit Trail.',
            },
            {
                area: 'Senarai',
                title: 'Senarai Utama disusun ikut tarikh key-in',
                detail: 'Aduan yang paling baharu dimasukkan ke sistem berada di atas. Tarikh dipaparkan dalam format Malaysia (contoh: 3 Jul 2026, 3:41 petang) dan baris tarikh yang berulang dibuang.',
            },
            {
                area: 'Senarai',
                title: 'Nama dan lajur Tindakan dalam huruf besar',
                detail: 'Nama orang dalam semua senarai (aduan, KES, i-Waran, Arahan Beredar, Kakitangan, Pengguna, Audit Trail) serta lajur Tindakan dalam Senarai Utama dipaparkan dalam huruf besar.',
            },
            {
                area: 'Senarai',
                title: 'Halaman senarai kekal selepas kembali',
                detail: 'Selepas membuka satu rekod dan menekan Kembali atau butang Back pelayar, pengguna kembali ke halaman senarai yang sama, bukan halaman 1.',
            },
            {
                area: 'Kes',
                title: 'No. Kes hanya dijana semasa simpan',
                detail: '"Tambah Kes Dari Aduan" dalam menu KES kini membuka borang kes dahulu. Nombor kes hanya diberi selepas butang "Simpan Kes & Jana No Kes" ditekan. Satu kes masih boleh mengandungi beberapa aduan dari daerah yang sama.',
            },
            {
                area: 'Laporan',
                title: 'Statistik i-WARAN',
                detail: 'Halaman baharu: status dan peringkat waran ikut daerah, bilangan dan hasil pelaksanaan, jenis kes dan mahkamah. Ada tapisan daerah dan tarikh serta eksport Excel.',
            },
            {
                area: 'Laporan',
                title: 'Statistik Aduan Keluarga (AK)',
                detail: 'Halaman baharu: subkategori, peringkat, Status Siasatan (IP), temujanji, pendakwaan, seksyen kesalahan dan mahkamah, semuanya ikut daerah. Ada eksport Excel.',
            },
            {
                area: 'Laporan',
                title: 'Angka statistik sepadan dengan tapisan',
                detail: 'Jika tapisan ditukar dengan cepat, angka tapisan lama tidak lagi terpapar.',
            },
            {
                area: 'E-mel',
                title: 'E-mel automatik ke inkuiri.gerakan@gmail.com',
                detail: 'Setiap e-mel Borang 5 (semasa Hantar ke Daerah) dan Laporan Tindakan (selepas laporan KES disimpan) dihantar ke emel pejabat daerah dengan salinan ke inkuiri.gerakan@gmail.com. Bagi daerah tanpa emel (Petaling, Shah Alam, Ampang), e-mel dihantar terus ke inkuiri.',
            },
            {
                area: 'E-mel',
                title: 'Tanda TESTING untuk aduan WhatsApp',
                detail: 'Subjek e-mel bagi aduan yang dibuat melalui WhatsApp bermula dengan "TESTING -" selagi saluran WhatsApp AI dalam ujian. Subjek Laporan Tindakan juga dibetulkan supaya "KES" tidak berulang.',
            },
            {
                area: 'Portal Awam',
                title: 'Butang Aduan WhatsApp AI',
                detail: 'Butang hijau di bucu kanan bawah semua halaman awam membuka WhatsApp untuk membuat aduan. Butang tersembunyi sehingga nombor bot ditetapkan oleh pentadbir sistem.',
            },
            {
                area: 'Portal Awam',
                title: 'Kad "Daftar Untuk Buat Aduan" disembunyikan',
                detail: 'Pendaftaran akaun awam ditutup sementara, jadi kad di halaman utama turut disembunyikan seperti butang Daftar yang lain.',
            },
            {
                area: 'Sistem',
                title: 'Pejabat PPA pada kad pengguna',
                detail: 'Kad pengguna di bar sisi memaparkan "PPA HQ" atau "PPA" diikuti nama daerah, contohnya PPA HULU LANGAT.',
            },
            {
                area: 'Manual',
                title: 'Manual Pengguna dikemas kini',
                detail: 'Manual dalam aplikasi dan laman /docs dikemas kini untuk semua perubahan di atas, termasuk 13 tangkap layar baharu dan halaman baharu "Paparan dan Borang Aduan".',
            },
        ],
    },
    {
        date: '14 September 2026',
        note: 'Pelaksanaan Kajian Keperluan Pengguna (URS) 4 September 2026.',
        items: [
            {
                area: 'Kes',
                title: 'No. kes dijana sekali sahaja (URS 1, 4)',
                detail: 'Nombor kes dijana semasa Simpan Kes, dan nombor yang sama dipaparkan pada aduan, senarai dan semua cetakan. Aduan berklasifikasi NFA tidak boleh dibuka sebagai kes.',
            },
            {
                area: 'Senarai',
                title: 'Senarai Utama, Lokasi Kejadian dan Status Terkini (URS 2)',
                detail: 'Menu dinamakan Senarai Utama, dengan lajur Lokasi Kejadian, Status Terkini dan nombor kes dalam senarai.',
            },
            {
                area: 'Senarai',
                title: 'Butang kembali (URS 3)',
                detail: 'Butang kembali membawa ke halaman senarai atau aduan asal, bukan ke permulaan.',
            },
            {
                area: 'Kes',
                title: 'Butang Muktamadkan (URS 5)',
                detail: 'Laporan Tindakan boleh dikunci supaya tidak boleh diubah. Hanya pentadbir boleh membuka kunci. Tarikh/Masa Daftar Laporan tidak lagi ditimpa.',
            },
            {
                area: 'Kes',
                title: 'Ringkasan KES: tarikh terima dan tindakan (URS 6)',
                detail: 'Tarikh/Masa Terima diambil dari Daftar Laporan, dan Tarikh/Masa Tindakan dari Tindakan di Lokasi.',
            },
            {
                area: 'E-mel',
                title: 'Salinan e-mel ke unit inkuiri (URS 7)',
                detail: 'E-mel Borang 5 dan Laporan Tindakan disalin kepada inkuiri.gerakan@gmail.com.',
            },
            {
                area: 'Laporan',
                title: 'Lajur No. Kes dalam Jana Tindakan Aduan (URS 8)',
                detail: 'Senarai Jana Tindakan Aduan memaparkan nombor kes bagi setiap aduan.',
            },
            {
                area: 'Aduan',
                title: 'Maklumat Tambahan Cerai tidak wajib (URS 9)',
                detail: 'Medan tambahan bagi aduan Cerai tidak lagi wajib diisi, kecuali daerah.',
            },
            {
                area: 'Aduan',
                title: 'Pegawai Inkuiri (PI) (URS 10, 13)',
                detail: 'Hanya Pegawai Inkuiri dan pentadbir boleh mengemas kini Maklumat Aduan, termasuk membetulkan daerah pada aduan portal dan WhatsApp. Pegawai lain masih boleh menyimpan Tindakan Pegawai.',
            },
            {
                area: 'Sistem',
                title: 'Nama kakitangan dalam huruf besar (URS 12)',
                detail: 'Nama kakitangan dan pengguna disimpan dalam huruf besar secara automatik.',
            },
            {
                area: 'Portal Awam',
                title: 'Pendaftaran akaun awam ditutup (URS 14)',
                detail: 'Butang Daftar pada portal awam disembunyikan buat sementara waktu.',
            },
            {
                area: 'i-Waran',
                title: 'Pembaikan modul i-Waran (URS 15)',
                detail: 'E-mel dihantar ke Email Daerah pada waran, lajur Tindakan Oleh dalam Senarai Waran, butang Kembali ke skrin sebelumnya, tarikh pelaksanaan kedua dan ketiga, serta jidar cetakan sama seperti Borang FIR.',
            },
            {
                area: 'Laporan',
                title: 'Laporan dan Data Statistik (URS 16)',
                detail: 'Satu halaman untuk klasifikasi AJ, aduan ikut daerah dan seksyen, kes tangkapan, OYDS dan rekod Arahan Beredar, dengan eksport Excel.',
            },
            {
                area: 'Aduan',
                title: 'Klasifikasi OP dibuang (URS 4)',
                detail: 'Pilihan Out of Procedure dibuang daripada klasifikasi. Keputusan ini dibatalkan pada 18 September 2026 atas permintaan pengguna.',
            },
            {
                area: 'WhatsApp',
                title: 'Aliran aduan WhatsApp mengikut skrip URS',
                detail: 'Bot WhatsApp (Syam) mengikut menu dan susunan soalan dalam URS, termasuk gambar MyKad, daerah, lokasi, butiran, ringkasan dan peringatan Seksyen 211.',
            },
            {
                area: 'Manual',
                title: 'Manual Pengguna',
                detail: 'Manual pengguna mengikut peranan dalam aplikasi (⋮ › Manual Pengguna dan butang ? Bantuan) serta laman /docs yang dilindungi kata laluan.',
            },
            {
                area: 'Sistem',
                title: 'Panel amaran pelayan ujian',
                detail: 'Jalur amaran kuning dipaparkan di bahagian atas pelayan ujian supaya pengguna tahu ia bukan sistem sebenar.',
            },
        ],
    },
];

export default CHANGELOG;
